import { render } from "./BackupIndex.vue?vue&type=template&id=29a5e409"
import script from "./BackupIndex.vue?vue&type=script&lang=js"
export * from "./BackupIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__